<template>
  <v-dialog
    v-model="dialog"
    scrollable
    persistent
    :max-width="dialogLargeSize ? '' : '600px'"
  >
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on" @click="getFormData">
        <img
          alt="edit"
          height="15"
          width="15"
          src="../../../assets/icons/edit.svg"
        />
      </v-btn>
    </template>

    <v-card>
      <v-toolbar dense flat dark color="primary" v-if="!loading">
        <v-btn icon dark @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title class="pl-0">{{ modalTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn class="mr-4" @click="resetForm" small outlined>
          Reiniciar
        </v-btn>
        <v-btn type="submit" :form="formId" small depressed light>
          Guardar
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container>
          <v-row>
            <v-progress-circular
              v-if="loading"
              class="my-12 prd-dialog-spinner"
              :size="50"
              :color="
                ['success', 'error', 'warning', 'info'][
                  Math.floor(Math.random() * 4)
                ]
              "
              indeterminate
            />
            <component
              :is="view"
              :formId="formId"
              @submitForm="submitForm"
              ref="form"
            />
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    itemId: {
      type: Number,
      required: true,
    },
    service: {
      type: Object,
      required: true,
    },
    dialogLargeSize: {
      type: Boolean,
      required: true,
    },
    dialogModelTitle: {
      type: String,
      required: true,
    },
    view: {
      type: Object,
      required: true,
    },
  },
  data: function() {
    return {
      dialog: false,
      formKey: 0,
      loading: null,
      itemTitle: "",
    }
  },
  methods: {
    cancel() {
      this.dialog = false
      this.resetForm()
    },
    resetForm() {
      this.formKey += 1
    },
    getFormData() {
      this.loading = !this.loading
      this.service.getItem(this.itemId).then(response => {
        this.$refs.form.fillForm(response.data)
        this.itemTitle = response.data.model[this.dialogModelTitle] || ""
        this.loading = !this.loading
      })
    },
    submitForm(data) {
      this.service
        .updateItem(this.itemId, data)
        .then(() => {
          this.$emit("updateTableItem")
        })
        .catch(error => {
          this.$notify({
            type: "error",
            title: this.$store.state.commonText.notification.errorTitle,
            text:
              this.$store.state.commonText.notification.errorText +
              "<br>" +
              error,
          })
        })
      this.dialog = false
    },
  },
  computed: {
    formId() {
      return this.service.name() + "_" + this.itemId
    },
    modalTitle() {
      return `#${this.itemId} | ${this.itemTitle}`
    },
  },
}
</script>

<style scoped />
